import styled from 'styled-components';

export default styled.div`
padding:40px;
`